import { shallow } from 'zustand/shallow';
import { createWithEqualityFn } from 'zustand/traditional';

export enum ToastIcon {
  ALERT = 'alert',
  CONFIRM = 'confirm',
  ERROR = 'error'
}

type ToastData = {
  message: string;
  icon: ToastIcon;
  duration?: number;
};

type ToastState = {
  toastData: ToastData | null;
};

type ToastAction = {
  showToast: (toastState: ToastData) => void;
};

export const useToastStore = createWithEqualityFn<ToastState & ToastAction>()(
  (set) => ({
    toastData: null,
    showToast: ({ message, icon, duration = 3000 }) => {
      set({ toastData: { message, icon, duration } });
      setTimeout(() => {
        set({ toastData: null });
      }, duration);
    }
  }),
  shallow
);
